<template>
  <header
    :style="{
      backgroundImage:
        'url(https://api-blog.institut-taxi.fr' + post.img.contentUrl + ')',
    }"
  >
    <div class="item">
      <div class="container">
        <div class="slide header-content">
          <div class="line"></div>
          <h1>{{ post.title }}</h1>
        </div>
      </div>
    </div>
  </header>
  <section class="container mt-5 pt-lg-5 post">
    <div v-html="post.content"></div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import { formatDate } from "@/assets/globalJs/global.js";
import Prism from "prismjs";
import { useMeta } from "vue-meta";
import { toRef } from "vue";
export default {
  name: "PostRead",
  setup(props) {
    const post = toRef(props, "post");
    const processContentForMetaDescription = (content, maxLength = 160) => {
      const contentWithoutStyles = content.replace(
        /<style([\s\S]*?)<\/style>/gi,
        ""
      );
      const contentWithoutTags = contentWithoutStyles.replace(/<[^>]+>/g, "");

      let metaDescription = contentWithoutTags.slice(0, maxLength);
      if (contentWithoutTags.length > maxLength) {
        metaDescription += "...";
      }

      return metaDescription;
    };
    const metaDescription = processContentForMetaDescription(
      post.value.content
    );

    useMeta({
      title: post.value.title,
      description: [
        {
          content: metaDescription,
        },
      ],
      link: [
        {
          rel: "canonical",
          href: "https://institut-taxi.fr/" + post.value.slug,
        },
      ],
    });
  },
  /*setup() {
    const post = "new titre";
    console.log(post);
    useMeta({
      title: post,
      description: [
        {
          content:
            "Nubetec: Pionnier du Cool Roof pour toitures éco-responsables. Réduisez la chaleur, économisez l'énergie et contribuez à un avenir durable. Contactez-nous dès maintenant !",
        },
      ],
      link: [
        {
          rel: "canonical",
          href: "https://www.nubetec.fr",
        },
      ],
    });
  },*/
  props: {
    post: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      backgroundImage: this.post.img.contentUrl,
    };
  },
  computed: {
    hasBackgroundImage() {
      return this.backgroundImage !== undefined;
    },
    formattedDate() {
      return formatDate(this.post.updatedAt);
    },
    ...mapGetters({
      Posts: "StatePosts",
      User: "StateUser",
      Post: "StatePost",
    }),
  },
  mounted() {
    import("@/assets/globalJs/global.js").then((module) => {
      const { observeElements } = module;
      observeElements(".fall", ".slide-right", ".slide-left");
    });
    // Sélectionne toutes les balises img contenues dans la balise div avec la classe "post"
    const postImages = document.querySelectorAll(".post img");
    // Parcourt chaque balise img dans la classe "post"
    postImages.forEach((img) => {
      // Supprime toutes les balises style de l'image
      img.removeAttribute("style");

      // Ajoute la classe img-fluid et img-post à l'image
      img.classList.add("img-fluid", "img-post", "col-10");

      // Crée une nouvelle div parent
      const wrapper = document.createElement("div");
      wrapper.classList.add("container", "text-center", "my-5");

      // Insère la nouvelle div avant l'image existante
      img.parentNode.insertBefore(wrapper, img);

      // Déplace l'image à l'intérieur de la nouvelle div
      wrapper.appendChild(img);
      // apply Prism highlighting to the rendered content
      Prism.highlightAll();
    });
  },
};
</script>

<style lang="scss" scoped>
header {
  --nav-offset: 74.4px;
  @media screen and (min-width: 992px) {
    --nav-offset: 84.4px;
  }
  @include background-responsive;
  & .item {
    width: 100%;
    height: 100%;
    min-height: 50vh;
    padding: calc(75px + var(--nav-offset)) 0 75px;
    background: #002a549f;
  }
}
.header-content {
  position: relative;
  overflow: hidden;
  padding: 30px 0px 30px 40px;
  @media screen and (min-width: 992px) {
    padding: 56px;
  }
  & .line {
    display: inline-block;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    position: absolute;
    border: 9px solid $color-secondary;
    -webkit-clip-path: polygon(0 0, 60% 0, 36% 100%, 0 100%);
    clip-path: polygon(0 0, 60% 0, 36% 100%, 0 100%);
  }
  & p:first-of-type {
    font-family: "adam";
    color: #fff;
    font-size: 1.1em;
    @media screen and (min-width: 992px) {
      font-size: 1.6em;
    }
  }
  & h1 {
    font-family: "Spartan", "Arial Black", Arial, sans-serif;
    font-weight: 700;
    font-size: 1.5em;
    margin: 5px 0 20px;
    word-spacing: 3px;
    color: #fff;
    @media screen and (min-width: 992px) {
      font-size: 2.5em;
    }
  }
  & p:last-of-type {
    font-family: "adam";
    font-size: 1.1em;
    line-height: 1.4em;
    color: #fff;
    @media screen and (min-width: 992px) {
      font-size: 1.4em;
    }
  }
}

.fall.active {
  @include fall-down(1.2s);
}
.slide-right.active {
  @include slide-right(1.2s);
}
.slide-left.active {
  @include slide-left(1s);
}
.cadre-img {
  display: flex !important;
  justify-content: center !important;
}
h2 {
  display: inline-block;
  position: relative;
  margin-top: 50px;
  margin-bottom: 50px !important;
  padding: 10px 8px 10px 5px; /* Espacement interne pour le contenu du titre */
  background-color: $color-primary; /* Couleur de fond de la bannière */
  color: $color-text-light; /* Couleur du texte */
  z-index: 1;
  @media screen and (min-width: 992px) {
    padding: 10px 100px 10px 8px;
  }
  @media screen and (max-width: 330px) {
    padding: 5px 10px 5px 5px;
  }
}

h2:before {
  content: "";
  position: absolute;
  top: 0;
  right: -10px; /* Ajustez cette valeur pour contrôler l'angle de la diagonale */
  bottom: 0;
  width: 50%;
  background-color: $color-primary; /* Couleur de fond de la bannière */
  transform: skewX(
    -16deg
  ); /* Ajustez cet angle pour contrôler l'inclinaison de la diagonale */
  z-index: -1;
}
</style>
